import React, { useContext, useState } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import MainToggle from '@wix/da-ds/pkg/formControls/dsPresets/MainToggle';
import ConfirmationModal from '../../../../../../Popup/ConfirmationModal';
import { Url } from '@wix/da-url';
import CoreUpgradeIndicator from '@wix/da-ds/pkg/Indicators/CoreUpgrade';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { useMMDispatch } from '../../../../../_hocs/withOwnReduxStore';
import { convertGallery } from '../../../../../actions';

import s from './PremiumContent.scss';

export interface Props {}

const PremiumContent: React.FC<Props> = () => {
  const { t } = useTranslation();
  const dispatchMM = useMMDispatch();
  const { hasCoreMembership } = useContext(SessionContext);

  const [showPremiumGalleryConversion, setShowPremiumGalleryConversion] =
    useState(false);

  return (
    <div>
      <div className={s['premium-gallery-form']}>
        <div>
          <div className={s['premium-gallery-label']}>
            {t('mediapopup.gallections.input.premium_gallery')}
          </div>
          <div className={s['premium-gallery-subtitle']}>
            {t('mediapopup.gallections.input.premium_gallery.subtitle')}
          </div>
        </div>
        <MainToggle
          className={s['premium-gallery-toggle']}
          variant="main"
          value={showPremiumGalleryConversion}
          onChange={setShowPremiumGalleryConversion}
          hasAccessibleLabel
          size="medium"
          type="button"
        />
      </div>
      <div
        className={c(
          s['premium-gallery-options'],
          showPremiumGalleryConversion && s['premium-gallery-options-visible']
        )}
      >
        {!hasCoreMembership && (
          <div className={s['premium-gallery-upsell']}>
            {t('mediapopup.gallections.gallery.paid.upgrade')}
            <a href={Url.coreMembershipLink()}>
              <CoreUpgradeIndicator
                className={s['premium-gallery-upsell-button']}
              >
                {t('deviationSubmit.modals.coreMonetizationUpsell.cta')}
              </CoreUpgradeIndicator>
            </a>
          </div>
        )}
      </div>
      {showPremiumGalleryConversion && hasCoreMembership && (
        <ConfirmationModal
          title={t(`mediapopup.gallections.input.premium_gallery.modal.title`)}
          text={
            <div>
              {t('mediapopup.gallections.input.premium_gallery.modal.text')}
            </div>
          }
          confirmBtnLabel={t(
            `mediapopup.gallections.input.premium_gallery.modal.confirm`
          )}
          useTransparentOverlay={false}
          cancelBtnLabel={t('common.cancel')}
          confirmBtnType={'default'}
          onConfirm={() => dispatchMM(convertGallery())}
          onCancel={() => setShowPremiumGalleryConversion(false)}
          onRequestClose={() => setShowPremiumGalleryConversion(false)}
          isOpen={showPremiumGalleryConversion}
        />
      )}
    </div>
  );
};
PremiumContent.displayName = 'PriceField';

export default PremiumContent;
